// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"e207103e","98":"46c532f4","212":"6606b681","243":"5c5d6d28","319":"670f5520","670":"2b5eebcd","755":"c4065d79","929":"57f560cc"}[chunkId] + ".chunk.js";
};